<mat-expansion-panel
	[expanded]="isExpanded"
	togglePosition="before"
	>
	<mat-expansion-panel-header
		collapsedHeight="41px"
		expandedHeight="41px"
		(click)="toggleExpand()"
		(keyup.enter)="toggleExpand()">
		<mat-panel-title>
			<span class="analytics-title-text">{{title}}</span>
			@if (helpDescription) {
				<span
					#helpIcon
					class="analytics-help-btn ficon-app-help-circle-outline"
					role="button"
					tabindex="0"
					[attr.aria-label]="'session-analytics_help-dialog-open' | translate : {chart: title}"
					[goCdkPopover]="helpDescription"
					[goCdkPopoverTrigger]="'click'"
					[goCdkPopoverPosition]="'below'"
					[goCdkPopoverOffsetY]="-8"
					[goCdkPopoverShowArrow]="true"
					[goCdkPopoverPanelClass]="'analytics-help-tooltip'"
					(click)="$event.stopPropagation()"
					(keydown.enter)="$event.stopPropagation(); helpIcon.click(); $event.preventDefault()"
					(keyup.enter)="$event.stopPropagation()"
					(keydown.space)="$event.stopPropagation(); helpIcon.click(); $event.preventDefault()"
					(keyup.space)="$event.stopPropagation()"
				></span>
			}
		</mat-panel-title>
		<mat-panel-description
			[attr.aria-hidden]="shouldTease">
			<span>{{dataSummary}}</span>
		</mat-panel-description>
	</mat-expansion-panel-header>

	<div class="graph">
		<ng-content select="[graph]"></ng-content>
	</div>
</mat-expansion-panel>
